<template>
	<div class="wholese">
		<div class="showcaseDiagram">
			<img :src="customerService.img" alt="" />
		</div>

		<div class="content wrapper1200">
			<div class="platform">
				<img src="../assets/image/platformIntroduction.png" alt="" />
			</div>

			<div class="contentDisplay" style="white-space: pre-wrap;">
				{{customerService.content}}
			</div>

		</div>

	</div>
</template>

<script>
	import {
		setContent
	} from "@/api/api.js"
	export default {
		data() {
			return {
				customerService: ''
			}
		},
		created() {
			this.userContent()
		},
		mounted() {


		},
		methods: {
			userContent() {
				setContent({
					groupKey: "home"
				}).then(res => {
					this.customerService = res.data
				})

			},

		}
	}
</script>
<style>
	body {
		background: #FFFCF6;
	}
</style>
<style lang="scss" scoped>
	.wholese {
		position: relative;
	}

	.leftImage {
		position: absolute;
		left: 0;
		bottom: -100px;
		width: 563px;
		height: 549px;

		img {
			width: 563px;
			height: 549px;
		}
	}

	.rightPicture {
		position: absolute;
		right: 0;
		bottom: 380px;
		width: 471px;
		height: 471px;

		img {
			width: 471px;
			height: 471px;
		}
	}

	.platform {
		width: 343px;
		height: 88px;
		margin: 50px auto;

		img {
			width: 343px;
			height: 88px;
		}
	}

	.contentDisplay {
		font-family: PingFang SC, PingFang SC;
		font-weight: 500;
		font-size: 24px;
		color: #92643D;
		line-height: 38px;
		letter-spacing: 3px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		padding-bottom: 246px;
	}

	.showcaseDiagram {
		width: 100%;
		height: 510px;

		img {
			width: 100%;
			height: 510px;
		}
	}
</style>